import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import { isObservableArray } from 'mobx'

export default function SelectedPermissionRoles () {
  const selectedRoles = useValue('list_of_roles')

  const roles = (Array.isArray(selectedRoles) || isObservableArray(selectedRoles)) ? selectedRoles : []

  if (roles.length === 0) {
    return <input name='selected_roles[]' type='hidden' />
  }

  return roles.map(name => <input key={name} name='selected_roles[]' type='hidden' value={name} />)
}
